/**
 * Format device name from user agent string
 * @param deviceName - Raw device name string from API
 * @returns Formatted device name string
 */
export const formatDeviceName = (deviceName: string | null | undefined): string => {
    // If it's empty we don't know 🤷‍♂️
    if (!deviceName || deviceName === '') return 'Unknown';

    const parts = deviceName.split('/').map(p => p.trim());

    // Need at least 3 parts for proper parsing
    if (parts.length < 3) return deviceName;

    const [, familyNameVer, browserNameVer] = parts;

    // Type guard to ensure we have the parts we need
    if (!familyNameVer || !browserNameVer) return deviceName;

    // remove version information if present.
    let familyName = familyNameVer
        .split(' ')
        .map(p => p.trim())
        .slice(0, -1)
        .join(' ');
    if (familyName === '') {
        // then there was no version information ...
        // restore that bad boy
        familyName = familyNameVer;
    }
    let browserName = browserNameVer
        .split(' ')
        .map(p => p.trim())
        .slice(0, -1)
        .join(' ');
    if (browserName === '') {
        // then there was no version information ...
        // restore that bad boy
        browserName = browserNameVer;
    }

    return `${browserName} - ${familyName}`;
};

/**
 * Format geo location string
 * @param geoLocation - Raw geo location string from API
 * @returns Formatted location string or 'Unknown'
 */
export const formatGeoLocation = (geoLocation: string | null | undefined): string => {
    if (!geoLocation) return 'Unknown';
    const location = geoLocation.trim();
    return location === '' ? 'Unknown' : location;
};
